'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';

const LIDataRetentionLink = ({
  children
}) => /*#__PURE__*/_jsx(UILink, {
  external: true,
  href: "https://docs.microsoft.com/en-us/linkedin/marketing/data-storage-requirements",
  children: children
});

const LIPurgedDataBanner = () => {
  const beforeDate = I18n.moment.portalTz().subtract(1, 'year').format('LL');
  return /*#__PURE__*/_jsx(UIAlert, {
    closeable: false,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dataPurgedBanner.title",
      options: {
        beforeDate
      }
    }),
    type: "warning",
    className: "m-bottom-4",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "dataPurgedBanner.body_jsx",
      options: {
        beforeDate
      },
      elements: {
        LIDataRetentionLink
      }
    })
  });
};

export default LIPurgedDataBanner;